import React from "react";
import Navigation from "../../organisms/Navigation/Navigation";
import Footer from "../../organisms/Footer/Footer";
import { Link } from "react-router-dom";
const Features = () => {
  return (
    <div>
      <Navigation />
      <ComingSoon />
      <Footer />
    </div>
  );
};
function ComingSoon() {
  return (
    <div style={{
                padding : "10%" ,
                paddingTop : "10vh"

    }}>
      <h1
        style={{
          fontSize: "4.8rem",
          fontFamily: "Quicksand",
        }}
      >
        Coming soon{" "}
      </h1>
      <Link
        to="/"
        style={{
          fontSize: "2.8rem",
          color: "hsla(219, 100%, 20%, 1)",
        }}
      >
        Go Home
      </Link>
    </div>
  );
}

export default Features;
